import { Box, Stack, Typography } from '@mui/material';
import { type GridRowIdGetter, type GridRowModel } from '@mui/x-data-grid-pro';
import { type JSX, type ReactNode } from 'react';

import { type DataGridColDef } from '../../../utils';
import { VeranstaltungenTable } from '../VeranstaltungenTable';

type ThemaCardProps<T extends GridRowModel> = {
  readonly thema: {
    titel: string;
    buchungsnummer: string;
    veranstaltungstypSapId: number;
    veranstaltungen: T[];
  };
  readonly columns: DataGridColDef<T>;
  readonly children: ReactNode;
  /**
   * This component is displaying a table of Veranstaltungen. Each row must have a unique identifier.
   *
   * @see https://mui.com/x/react-data-grid/row-definition/?srsltid=AfmBOoq7ohBDGz4Eskn9zWiGFHCDQT1E3IR-KopXXfYDeIwf5cBfE09U#row-identifier
   */
  readonly getRowId: GridRowIdGetter<T>;
};

export const ThemaCard = <T extends GridRowModel>({
  thema,
  columns,
  children,
  getRowId,
}: ThemaCardProps<T>): JSX.Element => (
  <Box>
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="column" sx={{ mb: 1 }}>
        <Typography variant="headingXxs">
          {thema.titel} ({thema.buchungsnummer})
        </Typography>
        <Typography variant="paragraphSm">SAP-ID: {thema.veranstaltungstypSapId}</Typography>
      </Stack>
      {children}
    </Stack>
    <VeranstaltungenTable veranstaltungen={thema.veranstaltungen} columns={columns} getRowId={getRowId} />
  </Box>
);
